import React from "react";
import { motion } from "framer-motion";
import styles from "./Card.module.scss";
import propTypes from "prop-types";

const contentVariants = {
  hidden: {
    opacity: 0,
    scale: 0.8,
  },
  visible: {
    opacity: 1,
    scale: 1,
  },
  exit: {
    opacity: 0,
    scale: 0.8,
  },
};

export default function Card({ children, className, style }) {
  return (
    <div
      style={style}
      className={styles.mainCard}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={contentVariants}
        transition={{ duration: 0.2 }}
        className={className}
      >
        {children}
      </motion.div>
    </div>
  );
}

Card.propTypes = {
  children: propTypes.node.isRequired,
  className: propTypes.string,
};
